export default __webpack_public_path__ + "static/media/gallery_28.6630e5c6.jpg";